import React from 'react';
import {
  Box,
  Typography,
  IconCheckCircle,
  Grid,
  GridItem,
  Button,
} from '@capitalise/ui-design-system';
import Confetti from 'react-confetti';

const featuresUnlockedText = [
  'Full Experian credit score used by banks and lenders.',
  'All risk factors and underlying criteria to understand what impacts your credit score.',
  'Credit history to see how your credit score changes over time.',
];

const ContentDefault = ({ completeOnboarding }: { completeOnboarding: () => void }) => {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Box
          width={160}
          height={160}
          position="relative"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Confetti
            width={640}
            height={640}
            confettiSource={{ x: 320, y: 320 }}
            tweenDuration={500}
            numberOfPieces={50}
            recycle={false}
            style={{
              position: 'absolute',
              left: '-320px',
              top: '-320px',
              marginLeft: '50%',
              marginTop: '50%',
            }}
          />
          <IconCheckCircle width={80} height={80} color="green" zIndex={1} />
        </Box>
      </Box>
      <Box marginBottom="3xsmall" textAlign="left">
        <Typography mt="small" mb="xsmall" size="heading-32" color="grey-900">
          Your details are verified!
        </Typography>
      </Box>
      <Typography size="heading-18" color="grey-900">
        Now you can access your full business credit profile:
      </Typography>
      {featuresUnlockedText.map((featureUnlocked, index) => (
        <Box display="list-item" mt="tiny" ml="xsmall" key={`features_unlocked_${index}`}>
          <Typography size="body-18" color="grey-700">
            {featureUnlocked}
          </Typography>
        </Box>
      ))}
      <Box
        position="fixed"
        bottom={0}
        left={0}
        backgroundColor="white"
        width="100%"
        paddingY="3xsmall"
        borderTop="1px solid"
        borderColor="grey-50"
        minHeight="3xlarge"
      >
        <Grid>
          <GridItem colSpan={4} />
          <GridItem colSpan={{ sm: 12, md: 12, default: 4 }}>
            <Button
              name="submit"
              type="submit"
              baseColor="green"
              variant="filled"
              data-testid="button-submit"
              fullWidth
              onClick={completeOnboarding}
            >
              Continue
            </Button>
          </GridItem>
          <GridItem colSpan={4} />
        </Grid>
      </Box>
    </>
  );
};

export default ContentDefault;
